import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {inject, Injector} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import {TenantConfigService} from '../service/tenant-config.service';
import Messages from './messages';

export class HttpErrorInterceptor implements HttpInterceptor {

  private injector = inject(Injector);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // withCredentials, damit das Session-Cookie auch beim cross-origin Dev-Setup
    // (ng serve :4200 -> Backend :8080) mitreist. Same-origin (Prod) ist es ein No-op.
    return next.handle(request.clone({withCredentials: true}))
      .pipe(
        catchError((error: HttpErrorResponse) => {
          let errorMsg = '';
          if (error.error instanceof ErrorEvent) {
            errorMsg = `Error: ${error.error.message}`;
          } else {
            const key = error.error.message;
            // @ts-ignore
            let msg = Messages[key];

            if (!msg) {
              msg = {
                title: 'Unerwarteter Fehler',
                body: 'Es ist ein unerwarteter Fehler aufgetreten. Bitte erneut versuchen.',
              }
            }

            // wrong_usertype/mail_error: Body ist tenant-spezifisch und kommt aus der Tenant-Config.
            const messages = this.injector.get(TenantConfigService).current.content.messages;
            Swal.fire({
              icon: 'error',
              title: msg.title,
              text: key === 'wrong_usertype' ? messages.wrongUsertypeBody
                : key === 'mail_error' ? messages.mailErrorBody
                : msg.body,
              showCloseButton: true,
            });
          }
          console.log(error);
          return throwError(errorMsg);
        }),
      )
  }
}
